import ModelUtil from '@leverege/model-util';
import I18N from '@leverege/i18n';
const TYPE = 'molten.googleMapRenderer.GeoLayerModel';
const {
  t
} = I18N.ns('molten.dataViewers.map.GeoLayerModel');

/**
 * This represents geo layers that have point objects. It will contain
 * options for the layer as whole, such as visibility options and selection
 * and rollover options.
 */
function create(layerName, name, objectType) {
  return {
    type: TYPE,
    name: name || t('unknownLayer'),
    objectType,
    layerName,
    visible: false,
    showAtZoom: 0,
    hideAtZoom: 23,
    fadeZoom: 0,
    rolloverable: true,
    selectable: true,
    startInteractionAtZoom: 0,
    stopInteractionAtZoom: 23,
    attrName: null
  };
}
export default {
  TYPE,
  create,
  getObjectType: m => m.objectType,
  ...ModelUtil.createAllValue('visible'),
  ...ModelUtil.createAllValue('showAtZoom'),
  ...ModelUtil.createAllValue('hideAtZoom'),
  ...ModelUtil.createAllValue('fadeZoom'),
  ...ModelUtil.createAllValue('rolloverable'),
  ...ModelUtil.createAllValue('selectable'),
  ...ModelUtil.createAllValue('startInteractionAtZoom'),
  ...ModelUtil.createAllValue('stopInteractionAtZoom'),
  ...ModelUtil.createAllValue('name'),
  ...ModelUtil.createAllValue('attrName', 'AttributeName')
};